import React, { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const SystemUsersPage = lazy(() => import("./SystemUsersPage"));

const SystemUsersRoutes = [
  {
    path: "/admin-users",
    element: <SystemUsersPage />,
    auth: authRoles.admin,
  },
];

export default SystemUsersRoutes;